module.exports.merlinPure = {
  vi: {
    title: 'Merlin thuần khiết (Merlin Pure) trong Avalon: vai trò nhìn thấy và ngoại lệ',
    description:
      'Merlin thuần khiết có thấy Mordred không? Không. Tìm hiểu các vai Ác được biến thể này của nền tảng tiết lộ, điểm khác Merlin và cách Ám sát.',
    keywords: ['Merlin thuần khiết', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Merlin Puro em Avalon: papéis visíveis e exceções',
    description:
      'Merlin Puro vê Mordred? Não. Conheça os papéis revelados por esta variante, a diferença para Merlin e o risco de assassinato.',
    keywords: ['Merlin Puro', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Merlin Pure in Avalon: Visible Roles & Exceptions',
    description:
      'Does Merlin Pure see Mordred? No. Learn which evil roles are revealed by this platform variant, how it differs from Merlin and how assassination works.',
    keywords: ['Merlin Pure', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Белый Мерлин в Авалоне: видимые роли и исключения',
    description:
      'Видит ли Белый Мерлин Мордреда? Нет. Какие роли он узнаёт, чем отличается от обычного Мерлина и как избежать финального убийства.',
    keywords: ['Белый Мерлин', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆終極梅林：可見角色與隱藏例外',
    description: '終極梅林能看到莫德雷德嗎？不能。了解本站梅林變體能識別的邪惡角色、仍然隱藏的例外，以及最終刺殺風險。',
    keywords: ['終極梅林', '角色', '規則', '建議'],
  },
  'zh-CN': {
    title: '阿瓦隆终极梅林：可见角色与隐藏例外',
    description: '终极梅林能看到莫德雷德吗？不能。了解本站梅林变体能识别的邪恶角色、仍然隐藏的例外，以及最终刺杀风险。',
    keywords: ['终极梅林', '角色', '规则', '建议'],
  },
  es: {
    title: 'Merlín Puro en Avalon: roles visibles y excepciones',
    description:
      '¿Merlín Puro ve a Mordred? No. Descubre qué roles malvados ve esta variante, su diferencia con Merlín y el riesgo de asesinato.',
    keywords: ['Merlín Puro', 'Rol', 'Reglas', 'Consejos'],
  },
};
